/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
 */

/*
 * The breakpoints exported here mirror the numbers
 * defined in css/abstracts/_breakpoints.css
 * Because sometimes, we need to access these values from JS
 * to turn behaviours on or off
 */
export default {
    width: {
        small: 576,
        medium: 767,
        large: 992,
        huge: 1200,
        massive: 1600
    },
    height: {
        small: 576
    }
};
